
export default function ProgrammesSection() {
  const programmes = [
    {
      title: 'Retail Operations Excellence',
      description: 'Comprehensive training covering customer service, inventory management, sales techniques, and retail best practices.',
      duration: '5 days',
      suitableFor: 'Retail managers, supervisors, and front-line staff',
      image: 'https://readdy.ai/api/search-image?query=Modern%20retail%20store%20training%20session%20with%20diverse%20staff%20learning%20customer%20service%20skills%2C%20professional%20retail%20environment%2C%20employees%20in%20uniform%20practicing%20sales%20techniques%2C%20bright%20store%20lighting%2C%20product%20displays%20in%20background%2C%20interactive%20training%20materials&width=400&height=250&seq=retail-001&orientation=landscape'
    },
    {
      title: 'Leadership & Management Development',
      description: 'Develop essential leadership skills including team management, strategic thinking, communication, and performance management.',
      duration: '3 days',
      suitableFor: 'Middle management, team leaders, and emerging leaders',
      image: 'https://readdy.ai/api/search-image?query=Professional%20leadership%20training%20workshop%20with%20diverse%20business%20executives%20in%20modern%20conference%20room%2C%20team%20building%20activities%2C%20leadership%20coaching%20session%2C%20collaborative%20learning%20environment%2C%20business%20professionals%20engaged%20in%20discussion&width=400&height=250&seq=leadership-001&orientation=landscape'
    }
  ];

  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Popular Corporate Training Programmes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our most requested training programmes designed to address key business challenges
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programmes.map((programme, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url('${programme.image}')` }}>
                <div className="h-full bg-black bg-opacity-20"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {programme.title}
                </h3>
                
                <p className="text-gray-600 mb-4">
                  {programme.description}
                </p>
                
                <div className="space-y-2 mb-6">
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2 text-[#2D7F3E]"></i>
                    <span><strong>Duration:</strong> {programme.duration}</span>
                  </div>
                  <div className="flex items-start text-sm text-gray-500">
                    <i className="ri-user-line mr-2 text-[#2D7F3E] mt-0.5"></i>
                    <span><strong>Suitable for:</strong> {programme.suitableFor}</span>
                  </div>
                </div>
                
                <button className="w-full btn btn-primary">
                  Request Proposal
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Need a custom programme? We can design training specifically for your industry and requirements.
          </p>
          <button className="btn btn-secondary">
            Discuss Custom Training
          </button>
        </div>
      </div>
    </section>
  );
}
